// src/Pages/Kuldevi/EditGotra.jsx

import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { closeModal } from '../../redux/features/modalSlice';
import { useUpdateKuldeviMutation } from '../../redux/services/kuldeviService/kuldevi.Services';
import { successToast, errorToast } from '../../Utils/toast';

function EditGotra({ data }) {
  const dispatch = useDispatch();
  const [updateKuldevi, { isLoading }] = useUpdateKuldeviMutation();
  
  const [formData, setFormData] = useState({
    kuldevi_name: '',
    status: 'active',
  });

  useEffect(() => {
    if (data) {
      setFormData({
        id: data.id || '',
        kuldevi_name: data.kuldevi_name || data.name || '',
        status: data.status || 'active',
      });
    }
  }, [data]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.kuldevi_name.trim()) {
      errorToast('Kuldevi name is required');
      return;
    }

    try {
      const payload = {
        id: data.id,
        kuldevi_name: formData.kuldevi_name,
        status: formData.status,
      };

      const response = await updateKuldevi(payload).unwrap();
      successToast(response?.message || 'Kuldevi updated successfully');
      dispatch(closeModal());
      // The page will auto-refresh due to RTK Query cache invalidation
      // No need for window.location.reload()
    } catch (error) {
      console.error('Update error:', error);
      errorToast(error?.data?.message || 'Failed to update kuldevi');
    }
  };

  return (
    <div className="edit-gotra-container">
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label className="form-label fw-bold">
            Kuldevi Name <span className="text-danger">*</span>
          </label>
          <input
            type="text"
            className="form-control"
            name="kuldevi_name"
            value={formData.kuldevi_name}
            onChange={handleChange}
            placeholder="Enter kuldevi name"
            required
            autoFocus
          />
        </div>

        <div className="mb-3">
          <label className="form-label fw-bold">Status</label>
          <select
            className="form-control"
            name="status"
            value={formData.status}
            onChange={handleChange}
          >
            <option value="active">Active</option>
            <option value="inactive">Inactive</option>
          </select>
        </div>

        <div className="d-flex justify-content-end gap-2 mt-4">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => dispatch(closeModal())}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="btn btn-primary"
            disabled={isLoading}
          >
            {isLoading ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" />
                Saving...
              </>
            ) : (
              'Save Changes'
            )}
          </button>
        </div>
      </form>
    </div>
  );
}

export default EditGotra;